// Componente encargado de armar las páginas de errores e información
// ============
import React from 'react';
// ============
import { useDispatch, useSelector } from 'react-redux';
import { enviarRespuestasEncuesta } from '../../../store/actions/encuestas';
// ============
import classes from './MensajeInfoerror.css';
import base from '../EncuestasPrincipal.css';
// ============
import Cabecera from '../../../components/Encuestas/Cabecera/Cabecera';

// Ícono según mensaje.imagen: 0 = cargando, 1 = error / aviso, 2 = respondida
const Icono = ({ imagen }) => {
  if (imagen === 0) {
    return <div className={classes.spinner} aria-hidden="true" />;
  }
  if (imagen === 2) {
    return (
      <svg className={`${classes.icono} ${classes.check}`} viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="30" />
        <path d="M19 33l9 9 17-19" />
      </svg>
    );
  }
  return (
    <svg className={`${classes.icono} ${classes.alerta}`} viewBox="0 0 64 64" aria-hidden="true">
      <circle cx="32" cy="32" r="30" />
      <path d="M32 17v20" />
      <circle className={classes.punto} cx="32" cy="46" r="3.2" />
    </svg>
  );
};

const MensajeInfoerror = ({ mensaje }) => {
  // Handler para reintentar el envío
  const dispatch = useDispatch();
  const contenidoEnvio = useSelector((state) => state.encuestas.contenidoEnvio); // Obtener contenidoEnvio
  const handleReintentarEnvio = () => {
    if (contenidoEnvio) {
      dispatch(enviarRespuestasEncuesta(contenidoEnvio)); // Reintentar con el contenido de envío guardado
    }
  };

  // Return del componente
  return (
    <>
      <Cabecera />
      <hr className={classes.div} />
      <div className={classes.estado}>
        <Icono imagen={mensaje?.imagen} />
        <h2>{mensaje.titulo}</h2>
        <p>{mensaje.texto1}</p>
        {mensaje?.error?.texto && (
          <p className={classes.detalle}>
            Detalle: <span>{mensaje.error.texto}</span>
          </p>
        )}
        {mensaje?.texto2 && (
          <p>
            <b>{mensaje.texto2}</b>
          </p>
        )}
        {mensaje?.mostrarBotonReenviar && (
          <button type="button" className={`${base.btn} ${base.prim} ${classes.boton}`} onClick={handleReintentarEnvio}>
            Reintentar
          </button>
        )}
      </div>
    </>
  );
};

export default MensajeInfoerror;
